import emma from '@/common/services/Emma'

const DocumentsResource = {
	getDocuments () { return emma.get('api/documents') },
	addDocument (document) { return emma.post('api/add-document', document) }
}

export default DocumentsResource



// WEBPACK FOOTER //
// ./src/common/resources/Documents.js